import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs  } from 'swiper/modules';

const apartmentsGalleryNav = new Swiper('.apartmentsGalleryNav', {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    slidesPerGroup: 3,
    watchSlidesProgress: true,
});

const apartmentsGallery = new Swiper('.apartmentsGallery', {
    loop: true,
    modules: [Thumbs, Pagination],
    thumbs: {
        swiper: apartmentsGalleryNav,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});
const floorSlider = new Swiper('.floorSlider', {
    modules: [Pagination],
    pagination: {
        el: ".floor-pagination",
        clickable: true,
    },
});
const oneBedApartments = new Swiper('.oneBedApartments', {
    loop: true,
    modules: [Navigation],
    navigation: {
        nextEl: ".ob-button-next",
        prevEl: ".ob-button-prev",
    },
});
const twoBedApartments = new Swiper('.twoBedApartments', {
    loop: true,
    modules: [Navigation],
    navigation: {
        nextEl: ".ob-button-next",
        prevEl: ".ob-button-prev",
    },
});
const threeBedApartments = new Swiper('.threeBedApartments', {
    loop: true,
    modules: [Navigation],
    navigation: {
        nextEl: ".ob-button-next",
        prevEl: ".ob-button-prev",
    },
});
const pentHouseApartments = new Swiper('.pentHouseApartments', {
    loop: true,
    modules: [Navigation],
    navigation: {
        nextEl: ".ob-button-next",
        prevEl: ".ob-button-prev",
    },
});
const amenitiesSlider = new Swiper('.amenitiesSlider', {
    modules: [Navigation],
    loop: true,
    navigation: {
        nextEl: ".a-button-next",
        prevEl: ".a-button-prev",
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    breakpoints: {
        480: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 30,
        }
    }
    
});
